import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HlmToaster } from '@spartan-ng/helm/sonner';

@Component({
  imports: [RouterOutlet, HlmToaster],
  selector: 'app-root',
  template: `
    <router-outlet />
    <hlm-toaster
      position="top-center"
      [richColors]="true"
      [toastOptions]="toastOptions"
      [style]="toasterStyle" />
  `,
})
export class App {
  readonly toastOptions = {
    classes: {
      title: 'text-right',
      description: 'text-right',
    },
  };

  readonly toasterStyle: Record<string, string> = {
    '--normal-bg': 'var(--popover)',
    '--normal-text': 'var(--popover-foreground)',
    '--normal-border': 'var(--border)',
    '--border-radius': 'var(--radius)',
    'direction': 'rtl',
  };
}
